import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UseresUrl = `${Base_Url}`;

export const GetUserNotificationList = async (UserKeyID) => {

  const res = await getApiWithAuthorization(
    `${UseresUrl}/Notification/GetNotificationList?UserKeyID=${UserKeyID.userKeyID}`,

  );
  return res;
};

export const NotificationView = async (NotificationKeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/Notification/ViewNotification?NotificationKeyID=${NotificationKeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const NotificationCount = async () => {
  const { userKeyID } = JSON.parse(localStorage.getItem("login"))

  const res = await getApiWithAuthorization(
    `${UseresUrl}/Notification/GetNotificationCount?UserKeyID=${userKeyID}`
  );
  return res;
};